import { render } from "./WeChatVisit.vue?vue&type=template&id=959ebb34&scoped=true"
const script = {}

import "./WeChatVisit.vue?vue&type=style&index=0&id=959ebb34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-959ebb34"]])

export default __exports__